import { RetailersStore } from 'src/modules/retailer';
import { BrandSpacesStore } from 'src/modules/brandSpaces';
import { DesignersStore } from 'src/modules/designers';
import { ProductsStore } from 'src/modules/products';
import { HeaderStore } from 'src/modules/layout';
import { PagesStore } from 'src/modules/pages';
import { ProfessionalsStore } from 'src/modules/professionals';
import { LocaleStore } from 'src/modules/locale';
import { CookiesStore } from 'src/modules/cookies';
import { ArticlesStore } from 'src/modules/articles';
import { SearchStore } from 'src/modules/search';
import { EventsStore } from 'src/modules/events';
import { JobsStore } from 'src/modules/jobs';

export type BaseStore = {
  retail: RetailersStore;
  brandSpaces: BrandSpacesStore;
  designers: DesignersStore;
  products: ProductsStore;
  header: HeaderStore;
  professionals: ProfessionalsStore;
  pages: PagesStore;
  locale: LocaleStore;
  cookies: CookiesStore;
  articles: ArticlesStore;
  search: SearchStore;
  events: EventsStore;
  jobs: JobsStore;
};

export type ActionCreatorType = (params?: any) => ActionType;
export type ActionCreatorAsyncType = (params?: any, params2?: any) => Promise<any>;

export interface ActionType {
  type: string;
  payload?: any;
}

export interface LoadingType {
  isLoading: boolean;
  isLoaded: boolean;
  error: any;
}

export interface CountryEntity {
  id?: string;
  code: string;
  name_en: string;
  name_de: string;
}

export interface CountryLocalizedEntity
  extends Pick<CountryEntity, Exclude<keyof CountryEntity, 'name_en' | 'name_de'>> {
  name: string;
}

export interface CityEntity {
  id?: string;
  name_en: string;
  name_de: string;
  country: CountryEntity;
}

export interface CityLocalizedEntity
  extends Pick<CityEntity, Exclude<keyof CityEntity, 'name_en' | 'name_de' | 'country'>> {
  name: string;
  country: CountryLocalizedEntity;
}

export enum Domains {
  deProd = 'www.walterknoll.de',
  usaProd = 'www.walter-k.com',
  ausProd = 'www.walterknoll.com.au',
}
